import { Observable } from 'rxjs';

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Store } from '@ngxs/store';

import { AsyncPipe, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { ɵNzTransitionPatchDirective } from 'ng-zorro-antd/core/transition-patch';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzSpaceCompactItemDirective } from 'ng-zorro-antd/space';
import { ActionsState } from '../../store/states/actions/actions.state';
import { ResendEmailVerification } from '../../store/states/user/user-state.actions';
import { UserState } from '../../store/states/user/user.state';

@Component({
  selector: 'adspt-email-verification',
  templateUrl: 'email-verification.component.html',
  styleUrls: ['email-verification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    NzAlertComponent,
    NzSpaceCompactItemDirective,
    NzButtonComponent,
    NzWaveDirective,
    ɵNzTransitionPatchDirective,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class EmailVerificationComponent {
  readonly emailVerified$: Observable<boolean> = this.store.select(UserState.emailVerified);

  readonly sending$: Observable<boolean> = this.store.select(ActionsState.whileAction(ResendEmailVerification));

  @Dispatch()
  readonly resendEmailVerification = () => new ResendEmailVerification();

  constructor(private store: Store) {}
}
